// @ts-nocheck




import { createAction, createSlice } from '@reduxjs/toolkit';

import type { Maintenance } from './../lib/types';

import { maintenanceApi } from './../lib/api';

import { defaultPageSize } from './constants';


export const FETCH_MAINTENANCES = 'vehicles/maintenance/fetch';



type MaintenancesState = {
  data: Maintenance[];
  page: number;
  pageSize: number;
  totalCount: number;
  filters: Record<string, unknown>;
};

type FetchMaintenancesPayload = Partial<MaintenancesState>;

const initialState: MaintenancesState = {
  data: [],
  page: 1,
  pageSize: defaultPageSize,
  totalCount: 0,
  filters: {}
};

const fetchMaintenancesAction = createAction<FetchMaintenancesPayload>(FETCH_MAINTENANCES);

const maintenancesSlice = createSlice({
  name: 'maintenances',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchMaintenancesAction, (state, { payload }) => ({ ...state, ...payload }));
  }
});

export const maintenancesActions = {
  fetch: fetchMaintenancesAction
};

export const fetchMaintenances = (
page = 1,
params = {}) =>
async (
dispatch,
getState) =>
{
  const { pageSize } = getState().maintenances;
  const { data, totalCount } = await maintenanceApi.fetchMaintenances({
    page,
    pageSize,
    ...params
  });
  dispatch(maintenancesActions.fetch({ data, totalCount, page, pageSize }));
};

export default maintenancesSlice.reducer;
